module.exports = __webpack_public_path__ + "img/Arabidopsis_lyrata.e42f582b.jpg";